/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import CollapsibleCalendar from './CollapsibleCalendar';
import SearchedCalendar from './SearchedCalendar';
import CollapsibleProgram from './CollapsibleProgram';
import {
  setSelectedReduxAthlete,
  setSelectedReduxNonDateBasedProgram,
  setSelectedProgramDayNumber,
  setSelectedDate,
  setSelectedReduxCalendar,
  setCreateModalProgramType,
  setProgramType,
} from '../../ducks/calendarActions';
import Spinner from '../../../../shared/components/Spinner/Spinner';
import CalendarSelectAthleteList from '../../modals/CalendarSelectAthleteList';

const PageWrapper = styled('div')`
  background: white;
  margin-top: ${(props) => (props.isModal ? '0' : '49px')};
  min-height: ${(props) => (props.isModal ? 'auto' : 'calc(100vh - 49px)')};
  display: flex;
  align-items: ${(props) => {
    if (props.isModal) return 'flex-start';
    if (props.scrollable) return 'flex-start';
    return 'center';
  }};
  justify-content: center;
  height: ${(props) => (props.isModal ? '100%' : 'auto')};
  overflow-y: ${(props) => (props.isModal ? 'visible' : props.scrollable ? 'auto' : 'visible')};
  max-height: ${(props) => (props.isModal ? 'none' : props.scrollable ? '100vh' : 'none')};
`;

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${(props) => (props.isModal ? '100%' : '752px')};
  padding: ${(props) => {
    if (props.isModal) return '0';
    if (props.compactMode) return props.scrollable ? '20px 10px 60px 10px' : '20px 10px';
    return '40px 20px';
  }};
`;

const HeaderSection = styled('div')`
  text-align: center;
  margin-bottom: ${(props) => (props.compactMode ? '15px' : '30px')};
  padding: ${(props) => (props.isModal ? '0 32px' : '0')};
`;

const MainHeading = styled('h1')`
  font-family: 'Nunito Sans';
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin: 0 0 10px 0;
  @media screen and (max-width: 768px) {
    font-size: 24px;
  }
  @media screen and (max-width: 480px) {
    font-size: 20px;
    line-height: 1.2;
  }
`;

const SubHeading = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  color: #999;
  margin: 0;
  @media screen and (max-width: 768px) {
    font-size: 14px;
  }
  @media screen and (max-width: 480px) {
    font-size: 13px;
  }
`;

const ProgramTypeContainer = styled('div')`
  display: flex;
  gap: 16px;
  width: 100%;
  margin-bottom: ${(props) => (props.compactMode ? '15px' : '30px')};
  @media screen and (max-width: 768px) {
    gap: 10px;
  }
  @media screen and (max-width: 480px) {
    gap: 8px;
  }
`;

const ProgramTypeButton = styled('div')`
  flex: 1;
  height: 56px;
  border: 2px solid ${(props) => (props.disabled ? '#E0E0E0' : props.selected ? '#4A90E2' : '#E0E0E0')};
  border-radius: 8px;
  background: ${(props) => (props.disabled ? '#F5F5F5' : props.selected ? '#F0F7FF' : 'white')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  transition: all 0.2s ease;
  opacity: ${(props) => (props.disabled ? '0.6' : '1')};

  &:hover {
    border-color: ${(props) => (props.disabled ? '#E0E0E0' : '#4A90E2')};
  }

  @media screen and (max-width: 768px) {
    height: 52px;
  }
  @media screen and (max-width: 480px) {
    height: 48px;
    gap: 6px;
  }
`;

const ProgramTypeText = styled('span')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => (props.disabled ? '#999' : props.selected ? '#4A90E2' : '#666')};
  @media screen and (max-width: 768px) {
    font-size: 15px;
  }
  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

const ContentWrapper = styled('div')`
  width: 100%;
`;

const InstructionText = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 400;
  color: #999;
  margin: ${(props) => (props.compactMode ? '0 0 10px 0' : '0 0 20px 0')};
  text-align: center;
`;

const ToggleContainer = styled('div')`
  display: flex;
  border-bottom: 1px solid #E0E0E0;
  margin-bottom: ${(props) => (props.compactMode ? '10px' : '20px')};
`;

const ToggleTab = styled('div')`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 15px 20px;
  border-bottom: ${(props) => (props.active ? '3px solid #4A90E2' : '3px solid transparent')};
  margin-bottom: -1px;
  transition: all 0.2s ease;
  @media screen and (max-width: 768px) {
    padding: 12px 14px;
  }
  @media screen and (max-width: 480px) {
    padding: 10px 10px;
  }
`;

const ToggleText = styled('span')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  color: ${(props) => (props.active ? '#4A90E2' : '#666')};
  white-space: nowrap;
`;

const SearchBarContainer = styled('div')`
  margin-bottom: ${(props) => (props.compactMode ? '10px' : '20px')};
  border: 2px solid #E0E0E0;
  border-radius: 8px;
  height: 48px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 16px;
  background: white;
  @media screen and (max-width: 480px) {
    padding: 0 12px;
  }
`;

const IconContainer = styled('div')`
  display: flex;
  align-items: center;
  margin-right: 12px;
`;

const SearchBar = styled('input')`
  width: 100%;
  border: none;
  font-family: 'Nunito Sans';
  font-size: 14px;
  outline: none;

  &::placeholder {
    color: #BDBDBD;
  }
`;

const CalendarsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: ${(props) => (props.compactMode ? '10px' : '20px')};
  height: 300px;
  overflow-y: auto;
  justify-content: ${(props) => (props.isLoading ? 'center' : 'flex-start')};
  align-items: ${(props) => (props.isLoading ? 'center' : 'stretch')};

  /* Hide the default scrollbar track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  /* Style the scrollbar thumb */
  &::-webkit-scrollbar {
    width: 6px;
  }

  /* Style the scrollbar thumb */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
`;

const AthleteListWrapper = styled('div')`
  margin-bottom: ${(props) => (props.compactMode ? '10px' : '20px')};
  height: 300px;
`;

const EmptyStateContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  margin-bottom: ${(props) => (props.compactMode ? '10px' : '20px')};
`;

const EmptyStateIcon = styled('div')`
  margin-bottom: 16px;
`;

const EmptyStateTitle = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
`;

const EmptyStateText = styled('p')`
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 400;
  color: #999;
  margin: 0 0 24px 0;
`;

const EmptyStateButton = styled('div')`
  font-family: 'Nunito Sans';
  width: 100%;
  max-width: 372px;
  height: 48px;
  padding: 0 16px;
  background: #444444;
  color: white;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  border: 2px solid #444444;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #333333;
    border-color: #333333;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }
`;

const NoResultsContainer = styled('div')`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 55px;
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 600;
  color: #444;
  padding: 10px;
`;

const ButtonsContainer = styled('div')`
  display: flex;
  gap: 12px;
  width: 100%;
  @media screen and (max-width: 768px) {
    gap: 10px;
  }
  @media screen and (max-width: 480px) {
    gap: 8px;
  }
`;

const ManageCalendarsButton = styled('div')`
  font-family: 'Nunito Sans';
  flex: 1;
  height: 48px;
  padding: 0 16px;
  color: ${(props) => (props.disabled ? 'rgb(189, 189, 189)' : '#444444')};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  user-select: none;
  border: 2px solid #E0E0E0;
  background: white;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  ${(props) => !props.disabled
    && `
      &:hover {
        border-color: #444444;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      }
    `}

  white-space: nowrap;

  @media screen and (max-width: 768px) {
    padding: 0 12px;
  }
  @media screen and (max-width: 480px) {
    padding: 0 10px;
    font-size: 13px;
  }
  @media screen and (max-width: 370px) {
    padding: 0 6px;
    font-size: 11px;
  }
`;

const NewCalendarButton = styled('div')`
  font-family: 'Nunito Sans';
  flex: 1;
  height: 48px;
  padding: 0 16px;
  background: #444444;
  color: white;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  user-select: none;
  border: 2px solid #444444;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #333333;
    border-color: #333333;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  white-space: nowrap;

  @media screen and (max-width: 768px) {
    padding: 0 12px;
  }
  @media screen and (max-width: 480px) {
    padding: 0 10px;
    font-size: 13px;
  }
  @media screen and (max-width: 370px) {
    padding: 0 6px;
    font-size: 11px;
    gap: 4px;
  }
`;

const EntryPointContent = ({ isModal = false, closeModal, onNext }) => {
  const [rightToggled, setRightToggled] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [isUserSearching, setIsUserSearching] = useState(false);
  const [isUserSearchingAthletes, setIsUserSearchingAthletes] = useState(false);
  const [searchedList, setSearchedList] = useState([]);
  const [searchedAthleteList, setSearchedAthleteList] = useState([]);
  const [searchedProgramsList, setSearchedProgramsList] = useState([]);

  const [compactMode, setCompactMode] = useState(false);
  const [scrollable, setScrollable] = useState(false);
  const globalProgramType = useSelector((state) => state.calendar.data.programType);
  const [programType, setLocalProgramType] = useState(globalProgramType);

  // Generate unique IDs for tooltips
  const calendarsTooltipId = 'calendars-info-tooltip';
  const programsTooltipId = 'programs-info-tooltip';
  const exercisesManagementAccessTooltipId = 'exercise-management-access-tooltip';

  const selectedReduxAthlete = useSelector((state) => state.calendar.data.selectedReduxAthlete);
  const selectedReduxCalendar = useSelector((state) => state.calendar.data.selectedReduxCalendar);
  const parentCalendars = useSelector((state) => state.calendar.data.parentCalendars);
  const isParentCalendarsLoading = useSelector(
    (state) => state.calendar.ui.isParentCalendarsLoading,
  );
  const calendarSelectAthletes = useSelector((state) => state.calendar.data.calendarSelectAthletes);
  const savedWorkouts = useSelector((state) => state.calendar.data.savedWorkouts);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  // null = full access, [] = no access, [id,...] = limited access
  const hasCalendarAccess = currentUser.calAccess === null
    || !!(currentUser.calAccess && currentUser.calAccess.length);

  const hasExerciseManagementAccess = currentUser?.userSettings?.exercises === 1;

  const dispatch = useDispatch();
  const history = useHistory();

  // Add ref for the calendar container
  const calendarContainerRef = useRef(null);
  // Add ref for the main container to detect overflow
  const containerRef = useRef(null);

  // Function to find calendar element by ID
  const findCalendarElementById = (id) => {
    if (!calendarContainerRef.current) return null;

    // Look for the calendar element with data-calendar-id attribute
    return calendarContainerRef.current.querySelector(`[data-calendar-id="${id}"]`);
  };

  // Effect to handle height detection and responsive behavior (only when not in modal mode)
  useEffect(() => {
    if (isModal) return undefined;

    const checkOverflow = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const availableHeight = window.innerHeight - 49; // Subtract header height
      const contentHeight = container.scrollHeight;

      if (contentHeight > availableHeight) {
        // Content exceeds available height
        if (!compactMode) {
          // First step: enable compact mode (halve margins)
          setCompactMode(true);
          setScrollable(false);
        } else {
          // Second step: make scrollable
          setScrollable(true);
        }
      } else if (compactMode) {
        // Check if we can exit compact mode
        // Calculate what height would be with normal margins
        // This is an approximation - we check if there's enough space
        const marginDifference = 150; // Approximate difference between normal and compact margins
        if (contentHeight + marginDifference <= availableHeight) {
          setCompactMode(false);
          setScrollable(false);
        }
      }
    };

    // Check overflow on mount and when dependencies change
    checkOverflow();

    // Set up ResizeObserver to watch for container size changes
    const resizeObserver = new ResizeObserver(() => {
      checkOverflow();
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    // Also listen to window resize
    window.addEventListener('resize', checkOverflow);

    return () => {
      resizeObserver.disconnect();
      window.removeEventListener('resize', checkOverflow);
    };
  }, [
    isModal,
    compactMode,
    rightToggled,
    programType,
    parentCalendars,
    savedWorkouts,
    isUserSearching,
    isUserSearchingAthletes,
  ]);

  // Effect to reset rightToggled when switching to programs
  useEffect(() => {
    if (programType === 'free-form-program') {
      setRightToggled(false);
    }
  }, [programType]);

  // Effect to handle initial selection of athletes
  useEffect(() => {
    if (selectedReduxAthlete && Object.keys(selectedReduxAthlete).length > 0) {
      setRightToggled(true);
    }
  }, [selectedReduxAthlete]);

  // Reset search state whenever the Calendars/Athletes toggle changes,
  // so a stale searchValue from one tab can't leak into the other.
  useEffect(() => {
    setSearchValue('');
    setIsUserSearching(false);
    setIsUserSearchingAthletes(false);
    setSearchedList([]);
    setSearchedProgramsList([]);
    setSearchedAthleteList([]);
  }, [rightToggled]);

  // Effect to scroll to selected calendar
  useEffect(() => {
    if (!rightToggled && selectedReduxCalendar && selectedReduxCalendar.id) {
      // Small delay to ensure DOM is rendered
      setTimeout(() => {
        const calendarElement = findCalendarElementById(selectedReduxCalendar.id);
        if (calendarElement) {
          // If parent is collapsed, expand it first
          const parentCollapsible = calendarElement.closest('.parent-calendar-container');
          if (parentCollapsible && !parentCollapsible.classList.contains('expanded')) {
            const toggleButton = parentCollapsible.querySelector('.toggle-button');
            if (toggleButton) toggleButton.click();
          }

          // Scroll the element into view
          calendarElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 350);
    }
  }, [selectedReduxCalendar, rightToggled, parentCalendars]);

  const clickAthlete = (athlete) => {
    dispatch(setProgramType('calendar'));
    dispatch(setSelectedReduxAthlete(athlete));

    if (isModal && closeModal) {
      closeModal();
    }
  };

  return (
    <PageWrapper isModal={isModal} scrollable={scrollable}>
      <Container
        isModal={isModal}
        compactMode={compactMode}
        scrollable={scrollable}
        ref={containerRef}
      >
        <HeaderSection compactMode={compactMode} isModal={isModal}>
          <MainHeading>What Do You Want to Build?</MainHeading>
          <SubHeading>Select a style of workout delivery to build in.</SubHeading>
        </HeaderSection>

        <ProgramTypeContainer compactMode={compactMode}>
          <ProgramTypeButton
            selected={programType === 'calendar'}
            onClick={() => {
              setLocalProgramType('calendar');
              dispatch(setCreateModalProgramType('calendar'));
            }}
          >
            <IcomoonReact
              iconSet={iconSet}
              size={20}
              icon='calendar'
              color={programType === 'calendar' ? '#4A90E2' : '#666'}
            />
            <ProgramTypeText selected={programType === 'calendar'}>
              Calendars
            </ProgramTypeText>
            <IcomoonReact
              iconSet={iconSet}
              size={16}
              icon='info2'
              color='#BDBDBD'
              style={{ cursor: 'pointer' }}
              data-tooltip-id={calendarsTooltipId}
            />
          </ProgramTypeButton>

          <ProgramTypeButton
            selected={programType === 'free-form-program'}
            onClick={() => {
              setLocalProgramType('free-form-program');
              dispatch(setCreateModalProgramType('free-form-program'));
            }}
          >
            <IcomoonReact
              iconSet={iconSet}
              size={20}
              icon='folder'
              color='#999'
            />
            <ProgramTypeText>
              Programs
            </ProgramTypeText>
            <IcomoonReact
              iconSet={iconSet}
              size={16}
              icon='info2'
              color='#BDBDBD'
              style={{ cursor: 'pointer' }}
              data-tooltip-id={programsTooltipId}
            />
          </ProgramTypeButton>
        </ProgramTypeContainer>

        <ContentWrapper>
          <InstructionText compactMode={compactMode}>
            {programType === 'free-form-program'
              ? 'Select a program to make edits or build a new one from scratch.'
              : 'Select a calendar to make edits or build a new one from scratch.'}
          </InstructionText>

          {programType !== 'free-form-program' && (
            <ToggleContainer compactMode={compactMode}>
              <ToggleTab active={!rightToggled} onClick={() => setRightToggled(false)}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={18}
                  icon='calendar'
                  color={!rightToggled ? '#4A90E2' : '#666'}
                />
                <ToggleText active={!rightToggled}>
                  Calendars
                </ToggleText>
              </ToggleTab>
              <ToggleTab active={rightToggled} onClick={() => setRightToggled(true)}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={18}
                  icon='user'
                  color={rightToggled ? '#4A90E2' : '#666'}
                />
                <ToggleText active={rightToggled}>
                  Athlete Calendars
                </ToggleText>
              </ToggleTab>
            </ToggleContainer>
          )}

          <SearchBarContainer compactMode={compactMode}>
            <IconContainer>
              <IcomoonReact
                iconSet={iconSet}
                size={18}
                icon='magnifying-glass'
                color='#BDBDBD'
              />
            </IconContainer>
            <SearchBar
              placeholder={`Search for ${!rightToggled ? (programType === 'free-form-program' ? 'a program' : 'a calendar') : 'an athlete'}`}
              value={searchValue}
              onChange={(e) => {
                if (!rightToggled) {
                  setSearchValue(e.target.value);
                  if (e.target.value.length > 0) {
                    setIsUserSearching(true);
                    if (programType === 'free-form-program') {
                      // Search programs
                      const newPrograms = savedWorkouts.filter(
                        (program) => program.programName.toLowerCase().includes(
                          e.target.value.toLowerCase(),
                        ),
                      );
                      setSearchedProgramsList(newPrograms);
                    } else {
                      // Search calendars
                      const newCalendars = [];
                      parentCalendars.forEach((parentCalendar) => {
                        if (parentCalendar.name.toLowerCase().includes(
                          e.target.value.toLowerCase(),
                        )) {
                          newCalendars.push(parentCalendar);
                        }
                        if (parentCalendar.childCalendars.length) {
                          parentCalendar.childCalendars.forEach((childCalendar) => {
                            if (childCalendar.name.toLowerCase().includes(
                              e.target.value.toLowerCase(),
                            )) {
                              newCalendars.push({
                                ...childCalendar,
                                parentCalendarInfo: {
                                  id: parentCalendar.id,
                                  name: parentCalendar.name,
                                },
                              });
                            }
                          });
                        }
                      });
                      setSearchedList(newCalendars);
                    }
                  } else {
                    setIsUserSearching(false);
                    setSearchedList([]);
                    setSearchedProgramsList([]);
                  }
                }
                if (rightToggled) {
                  setSearchValue(e.target.value);
                  if (e.target.value.length > 0) {
                    setIsUserSearchingAthletes(true);
                    const newList = calendarSelectAthletes.filter(
                      (item) => item.first.toLowerCase().includes(e.target.value.toLowerCase())
                  || item.last.toLowerCase().includes(e.target.value.toLowerCase()),
                    );
                    if (!newList.length) {
                      setSearchedAthleteList([{
                        first: 'No Athletes Found',
                        fake: true,
                        last: '',
                        pic: '',
                      }]);
                    } else {
                      setSearchedAthleteList(newList);
                    }
                  } else {
                    setIsUserSearchingAthletes(false);
                    setSearchedAthleteList([]);
                  }
                }
              }}
            />
          </SearchBarContainer>

          {!rightToggled ? (
            programType === 'free-form-program' ? (
              !isUserSearching
                    && (!savedWorkouts || savedWorkouts.length === 0) ? (
                      <EmptyStateContainer compactMode={compactMode}>
                        <EmptyStateIcon>
                          <IcomoonReact
                            iconSet={iconSet}
                            size={48}
                            icon='folder'
                            color='#BDBDBD'
                          />
                        </EmptyStateIcon>
                        <EmptyStateTitle>No Programs</EmptyStateTitle>
                        <EmptyStateText>Create your first program to get started</EmptyStateText>
                        <EmptyStateButton>
                          <IcomoonReact
                            iconSet={iconSet}
                            size={16}
                            icon='plus'
                            color='white'
                          />
                          New Program
                        </EmptyStateButton>
                      </EmptyStateContainer>
                ) : (
                  <CalendarsContainer
                    isLoading={false}
                    compactMode={compactMode}
                    ref={calendarContainerRef}
                  >
                    {!isUserSearching
                      ? savedWorkouts && savedWorkouts.length > 0 ? (
                        savedWorkouts.map((program) => (
                          <CollapsibleProgram
                            key={program.id}
                            program={program}
                            isModal={isModal}
                            closeModal={closeModal}
                          />
                        ))
                      ) : (
                        <NoResultsContainer>No Programs Found</NoResultsContainer>
                      )
                      : searchedProgramsList.length > 0
                        ? searchedProgramsList.map((program) => (
                          <CollapsibleProgram
                            key={program.id}
                            program={program}
                            isModal={isModal}
                            closeModal={closeModal}
                          />
                        ))
                        : <NoResultsContainer>No Programs Found</NoResultsContainer>}
                  </CalendarsContainer>
                )
            ) : (
              !isParentCalendarsLoading
                    && !isUserSearching
                    && parentCalendars.filter((calendar) => !calendar.archived).length === 0 ? (
                      <EmptyStateContainer compactMode={compactMode}>
                        <EmptyStateIcon>
                          <IcomoonReact
                            iconSet={iconSet}
                            size={48}
                            icon='calendar'
                            color='#BDBDBD'
                          />
                        </EmptyStateIcon>
                        <EmptyStateTitle>No Calendars</EmptyStateTitle>
                        <EmptyStateText>
                          {hasCalendarAccess
                            ? 'Create your first calendar to get started'
                            : 'No calendars are currently available.'}
                        </EmptyStateText>
                        {hasCalendarAccess && (
                          <EmptyStateButton onClick={() => {
                            if (isModal && onNext) {
                              onNext();
                            } else {
                              history.push('/calendar/create');
                            }
                          }}
                          >
                            <IcomoonReact
                              iconSet={iconSet}
                              size={16}
                              icon='plus'
                              color='white'
                            />
                            New Calendar
                          </EmptyStateButton>
                        )}
                      </EmptyStateContainer>
                ) : (
                  <CalendarsContainer
                    isLoading={isParentCalendarsLoading}
                    compactMode={compactMode}
                    ref={calendarContainerRef}
                  >
                    {isParentCalendarsLoading ? <Spinner /> : null}
                    {!isParentCalendarsLoading ? !isUserSearching
                      ? parentCalendars
                        .filter((calendar) => !calendar.archived)
                        .map((calendar, parentCalendarIndex) => (
                          <CollapsibleCalendar
                            key={calendar.id}
                            calendar={calendar}
                            parentCalendarIndex={parentCalendarIndex}
                            isSelected={calendar.id === selectedReduxCalendar?.id}
                            isModal={isModal}
                            closeModal={closeModal}
                          />
                        ))
                      : searchedList.length > 0
                        ? searchedList.map((calendar) => (
                          <SearchedCalendar
                            key={calendar.id}
                            calendar={calendar}
                            isSelected={calendar.id === selectedReduxCalendar?.id}
                            isModal={isModal}
                            closeModal={closeModal}
                          />
                        ))
                        : <NoResultsContainer>No Calendars Found</NoResultsContainer>
                      : null}
                  </CalendarsContainer>
                )
            )
          )
            : calendarSelectAthletes.length === 0 ? (
              <EmptyStateContainer compactMode={compactMode}>
                <EmptyStateIcon>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={48}
                    icon='user'
                    color='#BDBDBD'
                  />
                </EmptyStateIcon>
                <EmptyStateTitle>No Athletes</EmptyStateTitle>
                <EmptyStateText>No athletes are currently available.</EmptyStateText>
              </EmptyStateContainer>
            ) : (
              <AthleteListWrapper compactMode={compactMode}>
                <CalendarSelectAthleteList
                  searchedAthleteList={searchedAthleteList}
                  setSearchedAthleteList={setSearchedAthleteList}
                  calendarSelectAthletes={calendarSelectAthletes}
                  isUserSearching={isUserSearchingAthletes}
                  setIsUserSearching={setIsUserSearching}
                  reduxFunction={clickAthlete}
                />
              </AthleteListWrapper>
            )}

          {hasCalendarAccess && parentCalendars && parentCalendars.length && programType !== 'free-form-program' ? (
            <ButtonsContainer>
              <ManageCalendarsButton onClick={() => {
                history.push('/calendars');
                /** clear selected calendar or athlete so user
                 * will land back on the build landing page when they come back
                 */
                dispatch(setSelectedReduxAthlete({}));
                dispatch(setSelectedReduxCalendar({}));
                dispatch(setSelectedDate(new Date()));
              }}
              >
                Manage Calendars
              </ManageCalendarsButton>
              <NewCalendarButton onClick={() => {
                if (isModal && onNext) {
                  onNext();
                } else {
                  history.push('/calendar/create');
                  dispatch(setCreateModalProgramType('calendar'));
                }
              }}
              >
                <IcomoonReact
                  iconSet={iconSet}
                  size={16}
                  icon='plus'
                  color='white'
                />
                New Calendar
              </NewCalendarButton>
            </ButtonsContainer>
          ) : null}
          {savedWorkouts && savedWorkouts.length > 0 && programType === 'free-form-program' ? (
            <ButtonsContainer>
              <ManageCalendarsButton
                data-tooltip-id={programType === 'free-form-program' && !hasExerciseManagementAccess && exercisesManagementAccessTooltipId}
                disabled={programType === 'free-form-program' && !hasExerciseManagementAccess}
                onClick={() => {
                  if (!hasExerciseManagementAccess) return;
                  window.location = `${process.env.PHP_APP_URL
                || 'https://app.teambuildr.com'}/exercises?action=savedPrograms`;

                  /** clear selected program and day so user
                 * will land back on the build landing page when they come back
                 */
                  dispatch(setSelectedReduxNonDateBasedProgram({}));
                  dispatch(setSelectedProgramDayNumber(0));
                }}
              >
                Manage Programs
              </ManageCalendarsButton>
              <NewCalendarButton onClick={() => {
                if (isModal && onNext) {
                  onNext();
                } else {
                  history.push('/program/create');
                  dispatch(setCreateModalProgramType('free-form-program'));
                }
              }}
              >
                <IcomoonReact
                  iconSet={iconSet}
                  size={16}
                  icon='plus'
                  color='white'
                />
                New Program
              </NewCalendarButton>
            </ButtonsContainer>
          ) : null}
        </ContentWrapper>
      </Container>

      {/* ReactTooltip components */}
      <ReactTooltip
        id={calendarsTooltipId}
        place='bottom'
        content='Traditional date-based approach to programming. Select this program type if you are basing your program around a calendar.'
        style={{
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: 'white',
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
          maxWidth: '450px',
          padding: '10px 16px',
        }}
      />

      <ReactTooltip
        id={programsTooltipId}
        place='bottom'
        content="Build programs with week and day numbers. Select this program type if you'd like to create self-paced programs."
        style={{
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: 'white',
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
          maxWidth: '450px',
          padding: '10px 16px',
        }}
      />
      <ReactTooltip
        id={exercisesManagementAccessTooltipId}
        place='bottom'
        content='You do not have the user permissions required to manage programs. Please Contact your administrator for more details.'
        style={{
          backgroundColor: 'rgba(68, 68, 68, 1)',
          color: 'white',
          fontFamily: 'Nunito Sans',
          fontSize: '13px',
          maxWidth: '450px',
          padding: '10px 16px',
        }}
      />
    </PageWrapper>
  );
};

EntryPointContent.propTypes = {
  isModal: PropTypes.bool,
  closeModal: PropTypes.func,
  onNext: PropTypes.func,
};

EntryPointContent.defaultProps = {
  isModal: false,
  closeModal: null,
  onNext: null,
};

export default EntryPointContent;
